"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavouriteRemoved = void 0;
const wishlist_event_1 = require("./wishlist-event");
class FavouriteRemoved extends wishlist_event_1.WishlistEvent {
    constructor(userId, studyId, eventId, stateHash, dateRemoved, isLocal) {
        super(dateRemoved);
        this.userId = userId;
        this.studyId = studyId;
        this.eventId = eventId;
        this.stateHash = stateHash;
        this.dateRemoved = dateRemoved;
        this.isLocal = isLocal;
        this.eventType = FavouriteRemoved.EventType;
        this.eventVersion = '1.0.0';
    }
    static create(userId, studyId, stateHash, dateRemoved, isLocal) {
        return new FavouriteRemoved(userId, studyId, wishlist_event_1.WishlistEvent.generateId(), stateHash, dateRemoved, isLocal);
    }
}
exports.FavouriteRemoved = FavouriteRemoved;
FavouriteRemoved.EventType = 'FavouriteRemoved';
